<template>
  <div class="sticky-credit">
    <transition name="sticky-credit__fade">
      <b-badge v-show="visible" pill variant="primary" class="sticky-credit__badge">
        <availability />
      </b-badge>
    </transition>
  </div>
</template>

<script>
import Availability from './header/availability.vue'

export default {
  name: 'sticky-credit',

  components: {
    'availability': Availability,
  },

  props: {
    // selettore dell'header: finché è in viewport il componente resta nascosto
    header_selector: {
      type: String,
      default: '.site-header',
    },
    // selettore del footer: quando entra in viewport il componente viene nascosto
    footer_selector: {
      type: String,
      default: '.site-footer',
    },
  },

  data() {
    return {
      header_visible: true,
      footer_visible: false,
    }
  },

  computed: {
    visible() {
      return !this.header_visible && !this.footer_visible
    },
  },

  mounted() {
    // Assegnazione diretta sull'istanza così Vue non li rende reattivi
    this.header_observer = this.create_observer(
      this.header_selector,
      (isIntersecting) => { this.header_visible = isIntersecting }
    )
    this.footer_observer = this.create_observer(
      this.footer_selector,
      (isIntersecting) => { this.footer_visible = isIntersecting }
    )
  },

  beforeDestroy() {
    if (this.header_observer) this.header_observer.disconnect()
    if (this.footer_observer) this.footer_observer.disconnect()
  },

  methods: {
    create_observer(selector, onIntersect) {
      if (typeof IntersectionObserver === 'undefined') return null

      const element = document.querySelector(selector)
      if (!element) {
        this.log.warn(`[sticky-credit]: "${selector}" non trovato`)
        return null
      }

      const observer = new IntersectionObserver(
        ([entry]) => onIntersect(entry.isIntersecting),
        { threshold: 0 }
      )
      observer.observe(element)
      return observer
    },
  },
}
</script>

<style lang="scss" scoped>

  .sticky-credit {

    &__fade-enter-active,
    &__fade-leave-active {
      transition: opacity 0.3s ease;
    }

    &__fade-enter,
    &__fade-leave-to {
      opacity: 0;
    }

    &__badge {
      font-weight: inherit;
      font-size: $font-size-md;
      box-shadow: 1px 1px 5px rgba(0, 0, 0, .25);
      border: 2px solid rgba(255, 255, 255, .3);
    }

    ::v-deep {

      .availability {
        &__icon {
          display: none;
        }
        &__label {
          max-width: 100px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: normal;

          // media custom per nascondere credito sticky
          @media (max-width: 1840px) {
            max-width: 50px;
          }
        }
        &__points {
          &-image {
            filter: drop-shadow(2px 2px 3px #fff)
          }
        }
      }
    }
  }

</style>
